import { render, staticRenderFns } from "./memberCollection.vue?vue&type=template&id=5e424446&scoped=true"
import script from "./memberCollection.vue?vue&type=script&lang=js"
export * from "./memberCollection.vue?vue&type=script&lang=js"
import style0 from "./memberCollection.vue?vue&type=style&index=0&id=5e424446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e424446",
  null
  
)

export default component.exports